import React from "react"
import ReactDOM from "react-dom"

import reportWebVitals from "./reportWebVitals"
import App from "./App"
import { Web3ReactProvider } from "@web3-react/core"
import { ClientsProvider } from "clients.context"
import { getLibrary } from "features/web3/utils"

ReactDOM.render(
  <React.StrictMode>
    <Web3ReactProvider getLibrary={getLibrary}>
      <ClientsProvider>
        <App />
      </ClientsProvider>
    </Web3ReactProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
